/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';
import type { ApiFilteredAlertReasonsInner } from './ApiFilteredAlertReasonsInner';
import {
    ApiFilteredAlertReasonsInnerFromJSON,
    ApiFilteredAlertReasonsInnerFromJSONTyped,
    ApiFilteredAlertReasonsInnerToJSON,
    ApiFilteredAlertReasonsInnerToJSONTyped,
} from './ApiFilteredAlertReasonsInner';
import type { ApiAlertedEntity } from './ApiAlertedEntity';
import {
    ApiAlertedEntityFromJSON,
    ApiAlertedEntityFromJSONTyped,
    ApiAlertedEntityToJSON,
    ApiAlertedEntityToJSONTyped,
} from './ApiAlertedEntity';

/**
 * a Filtered Alert
 * @export
 * @interface ApiFilteredAlert
 */
export interface ApiFilteredAlert {
    /**
     * 
     * @type {number}
     * @memberof ApiFilteredAlert
     */
    screeningAlertId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiFilteredAlert
     */
    monitoringAlertId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiFilteredAlert
     */
    bridgeAlertId?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiFilteredAlert
     */
    manualAlertId?: number;
    /**
     * 
     * @type {ApiAlertedEntity}
     * @memberof ApiFilteredAlert
     */
    alertedEntity?: ApiAlertedEntity;
    /**
     * 
     * @type {Date}
     * @memberof ApiFilteredAlert
     */
    createdTime: Date;
    /**
     * 
     * @type {Date}
     * @memberof ApiFilteredAlert
     */
    statusUpdatedTime?: Date;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiFilteredAlert
     */
    assignee?: ApiAssignmentUser;
    /**
     * 
     * @type {number}
     * @memberof ApiFilteredAlert
     */
    statusId: number;
    /**
     * 
     * @type {Array<ApiFilteredAlertReasonsInner>}
     * @memberof ApiFilteredAlert
     */
    reasons: Array<ApiFilteredAlertReasonsInner>;
}

/**
 * Check if a given object implements the ApiFilteredAlert interface.
 */
export function instanceOfApiFilteredAlert(value: object): value is ApiFilteredAlert {
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    if (!('reasons' in value) || value['reasons'] === undefined) return false;
    return true;
}

export function ApiFilteredAlertFromJSON(json: any): ApiFilteredAlert {
    return ApiFilteredAlertFromJSONTyped(json, false);
}

export function ApiFilteredAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiFilteredAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'screeningAlertId': json['screeningAlertId'] == null ? undefined : json['screeningAlertId'],
        'monitoringAlertId': json['monitoringAlertId'] == null ? undefined : json['monitoringAlertId'],
        'bridgeAlertId': json['bridgeAlertId'] == null ? undefined : json['bridgeAlertId'],
        'manualAlertId': json['manualAlertId'] == null ? undefined : json['manualAlertId'],
        'alertedEntity': json['alertedEntity'] == null ? undefined : ApiAlertedEntityFromJSON(json['alertedEntity']),
        'createdTime': (new Date(json['createdTime'])),
        'statusUpdatedTime': json['statusUpdatedTime'] == null ? undefined : (new Date(json['statusUpdatedTime'])),
        'assignee': json['assignee'] == null ? undefined : ApiAssignmentUserFromJSON(json['assignee']),
        'statusId': json['statusId'],
        'reasons': ((json['reasons'] as Array<any>).map(ApiFilteredAlertReasonsInnerFromJSON)),
    };
}

export function ApiFilteredAlertToJSON(json: any): ApiFilteredAlert {
    return ApiFilteredAlertToJSONTyped(json, false);
}

export function ApiFilteredAlertToJSONTyped(value?: ApiFilteredAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'screeningAlertId': value['screeningAlertId'],
        'monitoringAlertId': value['monitoringAlertId'],
        'bridgeAlertId': value['bridgeAlertId'],
        'manualAlertId': value['manualAlertId'],
        'alertedEntity': ApiAlertedEntityToJSON(value['alertedEntity']),
        'createdTime': value['createdTime'].toISOString(),
        'statusUpdatedTime': value['statusUpdatedTime'] == null ? value['statusUpdatedTime'] : value['statusUpdatedTime'].toISOString(),
        'assignee': ApiAssignmentUserToJSON(value['assignee']),
        'statusId': value['statusId'],
        'reasons': ((value['reasons'] as Array<any>).map(ApiFilteredAlertReasonsInnerToJSON)),
    };
}

